export default __webpack_public_path__ + "static/media/coach-login.030389d2.png";